import type { Company, Job, Lead } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import { selectors } from "store";
import leadSelectors from "store/selectors/lead";

export interface LeadDetailsHook {
  lead?: Lead;
  company?: Company;
  jobs: Job[];
  isLoading: boolean;
}

export default function useLeadDetails(): LeadDetailsHook {
  const lead = useSelector(selectors.lead.getEntity);
  const companies = useSelector(selectors.company.getEntities);
  const jobs = useSelector(leadSelectors.getLeadJobs);
  const isLoading = useSelector(selectors.lead.getIsLoading);

  const company = companies[lead?.cid || ""];

  return {
    lead,
    company,
    isLoading,
    jobs,
  };
}
